export const SAVE_ANSWERS = 'SAVE_ANSWERS';
export const SAVE_SUBMISSION_ANSWERS = 'SAVE_SUBMISSION_ANSWERS';
